import React from "react";
import Axios from "axios";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch = async (error, errorInfo) => {
    // Catch errors in any components below and re-render with error message
    this.setState(
      {
        error: error,
        errorInfo: errorInfo,
        url: window.location.href,
      },
      async () => {
        await Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/frontend/error-catch", {
          error: this.state.error.toString(),
          errorInfo: this.state.errorInfo,
          url: this.state.url,
          auth_token: this.props.authToken,
        });
      },
    );
    // You can also log error messages to an error reporting service here
  };

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <main className="main h-100 w-100">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
                <div className="d-table-cell align-middle">
                  <div className="text-center">
                    <h1 className="display-1 fw-bold mt-7">500</h1>
                    <p className="h1">Internal server error.</p>
                    <p className="h2 fw-normal mt-3 mb-4">The server encountered something unexpected that didn't allow it to complete the request.</p>
                    <p className="h5 fw-normal mt-3 mb-4">We have been notified of this error and are working to resolve it.</p>
                    <a href="/clients" className="btn btn-primary btn-lg">
                      Return to website
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
